import { useGenerateCertificate } from "@homesite/hooks";
import { ReportPreviewPage } from "@homesite/ui";
import { createRoute } from "@tanstack/react-router";
import { env } from "../lib/env";
import { rootRoute } from "./__root";

export const reportDetailRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/reports/$id",
	component: function ReportDetail() {
		const { id } = reportDetailRoute.useParams();
		const { isPending, isError, error, downloadUrl } = useGenerateCertificate(
			env.VITE_API_URL,
		);

		function handleDownload(): void {
			if (downloadUrl) {
				const a = document.createElement("a");
				a.href = downloadUrl;
				a.download = `report-${id}.pdf`;
				a.click();
			}
		}

		function handlePrint(): void {
			window.print();
		}

		return (
			<ReportPreviewPage
				report={null}
				generating={isPending}
				error={isError ? (error ?? new Error("Unknown error")) : null}
				onDownload={handleDownload}
				onPrint={handlePrint}
			/>
		);
	},
});
